<script lang="ts">
  import { onDestroy, onMount } from 'svelte';
  import { dayjs } from '../../lib/dayjs';
  import AiVerificationModal from '../_shared/AiVerificationModal.svelte';
  import EventQueue from '../../lib/custom-event';
  import { debugLog } from '../../lib/debug-log';
  import { getAuthHeaders } from '../../lib/authHeaders';
  import {
    getStandardFieldTransformations,
    CRITERIA_STATUS_FIELDS,
    CRITERIA_HIDDEN_FIELDS,
    ALL_CRITERIA_FIELDS,
    CRITERIA_DROPDOWN_FIELDS,
  } from '../../lib/agentTransformations';

  let URL = `${process.env.SVELTE_APP_REMOTE_URL}/api`;

  const mountAdminView = () => {
    document.getElementById('pre-payment').innerHTML = '';

    import('App/Purchasepaybacks').then((m) => {
      let module = m.default;

      new module({
        target: document.getElementById('pre-payment'),
        layout: 'auto',
        props: {
          dateFormat: 'DD.MM.YYYY - HH:mm',
          filter: {
            limit: 10,
            where: {
              and: [
                {
                  completed: 1,
                  status: 'PRE-PAYMENT',
                },
              ],
            },
          },
          defaultFilter: {
            date: {
              lt: dayjs().format(),
              gt: dayjs().subtract(30, 'day').format(),
            },
          },
          quickFilters: [
            {
              label: 'Last 30 days',
              filter: {
                date: {
                  lt: dayjs().format(),
                  gt: dayjs().subtract(30, 'day').format(),
                },
              },
            },
            {
              label: 'Last 60 days',
              filter: {
                date: {
                  lt: dayjs().format(),
                  gt: dayjs().subtract(60, 'day').format(),
                },
              },
            },
            {
              label: 'Last 90 days',
              filter: {
                date: {
                  lt: dayjs().format(),
                  gt: dayjs().subtract(90, 'day').format(),
                },
              },
            },
          ],
          schema: {
            'field-properties': {
              'field-order': [
                'id',
                'date',
                'completed',
                'status',
                'agentDecision',
                'agentFindings',
                ...CRITERIA_STATUS_FIELDS,
                'approvedDate',
                'paidDate',
                'cashbackType',
                'personalinformation',
                'purchasereceipts',
                'questions',
              ],
              'field-transformation': getStandardFieldTransformations(),
              'auto-generated-fields': ['id'],
              'boolean-fields': [
                'completed',
                'personalinformationOverride',
                'archived',
                'ibanVerified',
                'phoneVerified',
                'addressVerified',
                'dealerOverride',
                'partsOverrride',
                'purchaseDateOverride',
                'storageOverride',
                'switchOverride',
              ],
              'hidden-fields': ['rejectionReason', 'paidDate', 'paidByMbdDate', ...CRITERIA_HIDDEN_FIELDS],
              'readonly-fields': [
                'id',
                'purchasereceipts',
                'purchasereceiptsId',
                'personalinformation',
                'personalinformationId',
                'agentDecision',
                'agentFindings',
                ...ALL_CRITERIA_FIELDS,
              ],
              'textarea-fields': ['agentFindings'],
              'relational-fields': [
                {
                  name: 'personalinformation',
                  editable: true,
                },
                {
                  name: 'purchasereceipts',
                  editable: true,
                },
              ],
              'dropdown-fields': [
                ...CRITERIA_DROPDOWN_FIELDS,
                {
                  name: 'status',
                  default: {
                    label: 'VERIFICATION',
                    value: 'VERIFICATION',
                  },
                  options: [
                    {
                      label: 'INCOMPLETE',
                      value: 'INCOMPLETE',
                    },
                    {
                      label: 'REJECTED',
                      value: 'REJECTED',
                    },
                    {
                      label: 'VERIFICATION',
                      value: 'VERIFICATION',
                    },
                    {
                      label: 'PRE-APPROVED',
                      value: 'PRE-APPROVED',
                    },
                    {
                      label: 'APPROVED',
                      value: 'APPROVED',
                    },
                    {
                      label: 'PRE-PAYMENT',
                      value: 'PRE-PAYMENT',
                    },
                    {
                      label: 'PAID',
                      value: 'PAID',
                    },
                    {
                      label: 'PARKING1',
                      value: 'PARKING1',
                    },
                    {
                      label: 'PARKING2',
                      value: 'PARKING2',
                    },
                    {
                      label: 'PARKING3',
                      value: 'PARKING3',
                    },
                    {
                      label: 'PARKING4',
                      value: 'PARKING4',
                    },
                    {
                      label: 'PARKING5',
                      value: 'PARKING5',
                    },
                  ],
                },
                {
                  name: 'cashbackType',
                  default: {
                    label: 'cashback-basic',
                    value: 'cashback-basic',
                  },
                  options: [
                    {
                      label: 'cashback-basic',
                      value: 'cashback-basic',
                    },
                    {
                      label: 'cashback-full',
                      value: 'cashback-full',
                    },
                  ],
                },
              ],
              'json-fields': [
                {
                  field: 'address',
                  template: '${street}, ${zip} ${city}',
                },
              ],
            },
            'custom-bulk-actions': [
              {
                action: 'Approve',
                bulkFn: async (rows) => {
                  const promises = rows.map((row) => {
                    return new Promise((resolve) => {
                      const event = new CustomEvent('updateRow', {
                        detail: {
                          rowId: row,
                          fields: {
                            status: 'APPROVED',
                          },
                        },
                      });
                      window.dispatchEvent(event);
                      resolve();
                    });
                  });

                  debugLog(promises);
                  return promises;
                },
                singleFn: (row) => {
                  const event = new CustomEvent('updateRow', {
                    detail: {
                      rowId: row.id,
                      fields: {
                        status: 'APPROVED',
                      },
                    },
                  });
                  window.dispatchEvent(event);
                },
              },
              {
                action: 'Paid',
                bulkFn: async (rows) => {
                  const promises = rows.map((row) => {
                    return new Promise((resolve) => {
                      const event = new CustomEvent('updateRow', {
                        detail: {
                          rowId: row,
                          fields: {
                            status: 'PAID',
                            paidDate: new Date().toISOString(),
                          },
                        },
                      });
                      window.dispatchEvent(event);
                      resolve();
                    });
                  });

                  debugLog(promises);
                  return promises;
                },
                singleFn: (row) => {
                  const event = new CustomEvent('updateRow', {
                    detail: {
                      rowId: row.id,
                      fields: {
                        status: 'PAID',
                        paidDate: row.paidDate
                          ? undefined
                          : new Date().toISOString(),
                      },
                    },
                  });
                  window.dispatchEvent(event);
                },
              },
              {
                action: 'Run AI Verification',
                singleFn: (row: { id: number }) => {
                  runAiVerification(row.id);
                },
              },
            ],
          },
        },
      });
    });
  };

  let handleFindingsClick: (e: MouseEvent) => void;
  let aiModalOpen = false;
  let aiLoading = false;
  let aiProcessId: number | null = null;
  let aiDecision: 'APPROVABLE' | 'UNSURE' | 'NOT_APPROVABLE' | null = null;
  let aiFindings = '';
  let aiError = '';

  const runAiVerification = async (id: number) => {
    aiProcessId = id;
    aiDecision = null;
    aiFindings = '';
    aiError = '';
    aiLoading = true;
    aiModalOpen = true;
    try {
      const response = await fetch(`${URL}/purchasepaybacks/${id}/verify`, {
        method: 'POST',
        headers: getAuthHeaders(),
      });
      if (!response.ok) {
        throw new Error(`Verification failed (status ${response.status})`);
      }
      const result = await response.json();
      const verdict = result?.verdict;
      if (!verdict) {
        aiError = 'The agent did not return a result.';
      } else {
        aiDecision = verdict.decision ?? null;
        aiFindings = verdict.findings ?? '';
        if (result.stored) mountAdminView();
      }
    } catch (e) {
      aiError = (e as Error).message ?? 'AI verification failed.';
    } finally {
      aiLoading = false;
    }
  };

  onMount(() => {
    mountAdminView();
    window.addEventListener('updateRow', (e: any) => {
      debugLog('here', e.detail);
      eventQueue.enqueue(e.detail);
    });

    handleFindingsClick = (e: MouseEvent) => {
      const chip = (e.target as HTMLElement)?.closest('.agent-findings-chip');
      if (!chip) return;
      const idStr = chip.getAttribute('data-id');
      const findings = chip.getAttribute('data-findings');
      const decision = chip.getAttribute('data-decision');
      if (findings) {
        aiProcessId = idStr ? Number(idStr) : null;
        aiFindings = decodeURIComponent(findings);
        aiDecision = (decision as any) || null;
        aiError = '';
        aiLoading = false;
        aiModalOpen = true;
      }
    };
    document.addEventListener('click', handleFindingsClick);
  });

  onDestroy(() => {
    window.removeEventListener('updateRow', (e: any) => {
      debugLog(e.detail);
    });
    if (handleFindingsClick) {
      document.removeEventListener('click', handleFindingsClick);
    }
  });

  const updateRow = async (
    detail: { rowId: string; fields: any },
    skipMount = false,
  ) => {
    await fetch(`${URL}/purchasepaybacks/${detail.rowId}`, {
      method: 'PATCH',
      headers: getAuthHeaders(),
      body: JSON.stringify(detail.fields),
    });
    if (!skipMount) {
      mountAdminView();
    }
  };

  let progressBar: any;
  let showProgressBar = false;

  const updateProgressBar = (progress: number) => {
    debugLog({ progress });
    progressBar.style.width = `${progress}%`;
  };

  let eventQueue = new EventQueue(
    updateProgressBar,
    updateRow,
    (show: boolean) => {
      showProgressBar = show;
    },
  );
</script>

<AiVerificationModal
  bind:open={aiModalOpen}
  loading={aiLoading}
  processId={aiProcessId}
  decision={aiDecision}
  findings={aiFindings}
  errorMessage={aiError}
/>

<div id="pre-payment" />
<div
  class="fixed inset-0 z-50 flex items-center justify-center bg-gray-900/50 backdrop-blur-sm transition-opacity duration-300 {showProgressBar
    ? 'opacity-100'
    : 'pointer-events-none opacity-0'}"
>
  <div class="w-11/12 max-w-md rounded-lg bg-white p-6 shadow-xl">
    <div class="mb-3">
      <h3 class="text-lg font-medium text-gray-900">Processing...</h3>
      <p class="text-sm text-gray-500">
        Please wait while we update the records.
      </p>
    </div>

    <div class="h-2 w-full overflow-hidden rounded-full bg-gray-200">
      <div
        bind:this={progressBar}
        class="h-full w-0 rounded-full bg-blue-600 transition-all duration-300 ease-out"
      ></div>
    </div>
  </div>
</div>
